export default "__VITE_ASSET__CWKi48tq__"